import { ProductNames } from '@/components/providers/ApplicantContextProvider/ApplicantContextProvider.types';
import { Dialog } from '@/components/shared/components/Dialog';

import { AddConditionForm } from './AddConditionForm';
import { ModalContainer } from './ApplicantConditions.StyledComponents';
import { Condition } from './ApplicantConditions.types';

interface Props {
    applicantId: string;
    availableProducts: ProductNames[];
    visible: boolean;
    onClose: () => void;
    onAdded: (description: string) => void;
    parentConditionId?: string;
    /** When set, the dialog edits this existing condition instead of creating a new one. */
    editCondition?: Condition | null;
}

export const AddConditionDialog = ({
    applicantId,
    availableProducts,
    visible,
    onClose,
    onAdded,
    parentConditionId,
    editCondition,
}: Props) => (
    <Dialog
        id={editCondition ? 'edit-condition-modal' : 'add-condition-modal'}
        header={
            editCondition
                ? 'Edit Task/Condition'
                : `Add ${parentConditionId ? 'Follow-Up ' : ''}Task/Condition`
        }
        visible={visible}
        onHide={onClose}
        dismissableMask={false}
        data-testid={editCondition ? 'edit-condition-dialog' : 'add-condition-dialog'}
    >
        <ModalContainer>
            {visible ? (
                <AddConditionForm
                    applicantId={applicantId}
                    availableProducts={availableProducts}
                    parentConditionId={parentConditionId}
                    editCondition={editCondition ?? undefined}
                    onAdded={onAdded}
                    onCancel={onClose}
                />
            ) : null}
        </ModalContainer>
    </Dialog>
);
